import { defineComponent as _defineComponent } from 'vue'
import { PreferenceUpdateFnParam } from '@/plugins/preference'
import store from '@/store'
import { updateLocalPreference } from '@/store/modules/preferencesSetting'
import { EventBusKey } from '@/util/bus'
import EventBus from '@/util/bus'
import { matchHighlightBoardName } from '@/util/commonFun'
import { buryPointApi } from '@/util/commonFuncs'
import {
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
  watch,
  withDefaults,
} from 'vue'
import Vue from 'vue'

interface SurConItem {
  name: string
  shape: string
  type: string
  color: string
  thick: string
  long: number
  min_long: number
  width: number
  min_width: number
  area: number
  isHighPlank: string
  position: string
  [key: string]: any
}
interface PositionItem {
  label: string
  value: string
  [key: string]: any
}
interface Props {
  visible: boolean
  surplusConfirmList: Array<SurConItem>
  page?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'm-surplus-second-confirm',
  props: {
    visible: { type: Boolean, default: false },
    surplusConfirmList: { default: () => [] },
    page: { default: 'layout' }
  },
  emits: ['ok', 'cancel', 'delSecCon', 'checkWareCon'],
  setup(__props: any, { emit: emits }) {

const props = __props as { visible: boolean, surplusConfirmList: Array<SurConItem>, page: string }



const { proxy } = getCurrentInstance()!
const surplusConfirmColumn = ref([
  {
    dataIndex: 'name',
    key: 'name',
    title: '余料名称',
    width: 130,
    scopedSlots: { customRender: 'name' },
    ellipsis: true,
  },
  {
    dataIndex: 'shape',
    key: 'shape',
    title: '板材形状',
    scopedSlots: { customRender: 'shape' },
    ellipsis: true,
  },
  {
    dataIndex: 'type',
    key: 'type',
    title: '板材材质',
    ellipsis: true,
    scopedSlots: { customRender: 'type' },
  },
  {
    dataIndex: 'texDir',
    key: 'texDir',
    title: '纹理',
    ellipsis: true,
    scopedSlots: { customRender: 'texDir' },
  },
  {
    dataIndex: 'color',
    key: 'color',
    title: '板材颜色',
    ellipsis: true,
  },
  {
    dataIndex: 'thick',
    key: 'thick',
    title: '厚度',
    ellipsis: true,
  },
  {
    dataIndex: 'long',
    key: 'long',
    title: '长度',
    ellipsis: true,
    scopedSlots: { customRender: 'long' },
  },
  {
    dataIndex: 'min_long',
    key: 'min_long',
    title: '短边长度',
    ellipsis: true,
    scopedSlots: { customRender: 'min_long' },
  },
  {
    dataIndex: 'width',
    key: 'width',
    title: '宽度',
    ellipsis: true,
    scopedSlots: { customRender: 'width' },
  },
  {
    dataIndex: 'min_width',
    key: 'min_width',
    title: '短边宽度',
    ellipsis: true,
    scopedSlots: { customRender: 'min_width' },
  },
  {
    dataIndex: 'area',
    key: 'area',
    title: '面积',
    ellipsis: true,
    scopedSlots: { customRender: 'area' },
  },
  {
    dataIndex: 'surplus_trim_edge',
    key: 'surplus_trim_edge',
    title: '修边',
    ellipsis: true,
    scopedSlots: { customRender: 'surplus_trim_edge' },
  },
  {
    dataIndex: 'isHighPlank',
    key: 'isHighPlank',
    title: '高光板',
    ellipsis: true,
    scopedSlots: {
      customRender: 'isHighPlank',
    },
  },
  {
    dataIndex: 'highlight_surface',
    key: 'highlight_surface',
    title: '高光面',
    ellipsis: true,
    scopedSlots: {
      customRender: 'highlight_surface',
    },
  },
  {
    dataIndex: 'position',
    key: 'position',
    title: '存放位置',
    width: 190,
    scopedSlots: { customRender: 'position' },
    ellipsis: true,
  },
  {
    dataIndex: 'operation',
    key: 'operation',
    title: '操作',
    scopedSlots: { customRender: 'operation' },
    ellipsis: true,
  },
])
let copyColumn = ref<PositionItem[]>([])
let surConPositionList = ref([
  { label: '系统分配', value: 'systemAllocation' },
  { label: '余料清单', value: 'surplusMaterialList' },
])
let allSurplus = ref<any>([])
let isCloseWareCon = ref(false)

// 勾选关闭入库确认
function handleCloseWareCon() {
  updateLocalPreference({
    isSecondConfirm: !isCloseWareCon.value,
  })
}

function getSurplusShape(shape: number) {
  if (shape == 1) {
    return Vue.prototype.$translateLang('L形')
  } else if (shape == 2) {
    return Vue.prototype.$translateLang('异形')
  } else {
    return Vue.prototype.$translateLang('矩形')
  }
}

function getTexDir(texDir: string) {
  if (texDir == 'normal') {
    return Vue.prototype.$translateLang('竖纹')
  } else if (texDir == 'reverse') {
    return Vue.prototype.$translateLang('横纹')
  } else {
    return Vue.prototype.$translateLang('无纹理')
  }
}
function getHighlightSurfaceText(highlight_surface: number) {
  if (highlight_surface == 1) {
    return Vue.prototype.$translateLang('正面')
  } else if (highlight_surface == 2) {
    return Vue.prototype.$translateLang('反面')
  } else {
    return Vue.prototype.$translateLang('无正反')
  }
}
function handleOk() {
  emits('ok', props.surplusConfirmList)
}

function handleCancel() {
  emits('cancel')
}

// 入库确认弹窗 余料名称输入框失焦
function handleBlurSurplusName(e: Event, record: SurConItem) {
  record.name = e.target?.value.slice(0, 10)
}

function handleChangeSurplusName() {
  buryPointApi(props.page, 'edit_surplus_name')
}

// 入库确认弹窗 系统分配更改
function handleChangeSurPosition(val: string, record: SurConItem) {
  buryPointApi(props.page, 'change_sur_position')
  record.position = val
}

// 删除 余料入库二次确认数据
function handleDelSecCon(index: number) {
  buryPointApi(props.page, 'del_sec_con')
  emits('delSecCon', index)
}

// 获取余料库
function getSurplusStoreList() {
  const params = {
    search_key: '',
    search_val: '',
    page_no: 1,
    page_size: 500,
  }
  surConPositionList.value = [
    { label: '系统分配', value: 'systemAllocation' },
    { label: '余料清单', value: 'surplusMaterialList' },
  ]
  Vue.prototype.$getByToken(
    '/surplus/branch_warehouses',
    params,
    (res: any) => {
      if (res.status == 1 && res.data.branch_warehouses.length) {
        surConPositionList.value.push(
          ...res.data.branch_warehouses.map((item: any) => ({
            ...item,
            label: item.name,
            value: item.branch_no,
          }))
        )
      }
    }
  )
}

// 翻译余料入库二次确认表格表头列
function updateTransSurplusTable() {
  surplusConfirmColumn.value = copyColumn.value.map((item: any) => {
    return {
      ...item,
      title: Vue.prototype.$translateLang(item.translateKey),
      // 自定义头部单元格
      customHeaderCell: () => ({
        attrs: {
          // 可以在这里添加额外的属性，比如 title
          title: Vue.prototype.$translateLang(item.translateKey),
        },
      }),
    }
  })
}

/**
 * @description 添加事件监听
 */
function addBusEvent() {
  EventBus.$on(EventBusKey.TRANSLATE, updateTransSurplusTable)
}

/**
 * @description 取消事件监听
 */
function removeBusEvent() {
  EventBus.$off(EventBusKey.TRANSLATE, updateTransSurplusTable)
}
const surplus_trim_data = ref<any>({})
function updatePreference({ data, isErr }: PreferenceUpdateFnParam) {
  if (isErr) return
  data = data || store.state.preferencesSetting?.setting
  surplus_trim_data.value = data?.surplus_trim_data
}

function trimShowText(record: any) {
  if (record.trimming_method == 'custom') {
    if (record.surplus_trim_edge?.includes(',')) {
      const edges = record.surplus_trim_edge.split(',')
      return `上${edges[0]}-下${edges[1]}-左${edges[2]}-右${edges[3]}`
    }
    return record.surplus_trim_edge
  } else {
    return '/'
  }
}
watch(
  () => props.visible,
  (newVal: boolean) => {
    if (newVal) {
      getSurplusStoreList()
    }
  }
)

onMounted(() => {
  copyColumn.value = JSON.parse(JSON.stringify(surplusConfirmColumn.value)).map(
    (item: any) => ({
      ...item,
      translateKey: item.title,
    })
  )
  updateTransSurplusTable()
  addBusEvent()
  proxy.$preference.init(updatePreference, proxy.$route.path)
})

onUnmounted(() => {
  removeBusEvent()
})

return { __sfc: true,props, emits, proxy, surplusConfirmColumn, copyColumn, surConPositionList, allSurplus, isCloseWareCon, handleCloseWareCon, getSurplusShape, getTexDir, getHighlightSurfaceText, handleOk, handleCancel, handleBlurSurplusName, handleChangeSurplusName, handleChangeSurPosition, handleDelSecCon, getSurplusStoreList, updateTransSurplusTable, addBusEvent, removeBusEvent, surplus_trim_data, updatePreference, trimShowText, matchHighlightBoardName }
}

})